"use strict";
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUISchemas = exports.getCells = exports.getRenderers = exports.getDefaultData = exports.getAjv = exports.getUiSchema = exports.getSchema = exports.getData = void 0;
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var core_1 = require("./core");
var default_data_1 = require("./default-data");
var getData = function (state) {
    return core_1.extractData(get_1.default(state, 'jsonforms.core'));
};
exports.getData = getData;
var getSchema = function (state) {
    return core_1.extractSchema(get_1.default(state, 'jsonforms.core'));
};
exports.getSchema = getSchema;
var getUiSchema = function (state) {
    return core_1.extractUiSchema(get_1.default(state, 'jsonforms.core'));
};
exports.getUiSchema = getUiSchema;
var getAjv = function (state) { return core_1.extractAjv(get_1.default(state, 'jsonforms.core')); };
exports.getAjv = getAjv;
var getDefaultData = function (state) {
    return default_data_1.extractDefaultData(get_1.default(state, 'jsonforms.defaultData'));
};
exports.getDefaultData = getDefaultData;
var getRenderers = function (state) { return get_1.default(state, 'jsonforms.renderers'); };
exports.getRenderers = getRenderers;
var getCells = function (state) { return get_1.default(state, 'jsonforms.cells'); };
exports.getCells = getCells;
var getUISchemas = function (state) { return get_1.default(state, 'jsonforms.uischemas'); };
exports.getUISchemas = getUISchemas;
//# sourceMappingURL=selectors.js.map